import type { ReportSubscriptionCadence } from '../types';

const SEND_HOUR = 6;

/**
 * When a new subscription first sends: 06:00 on the cadence's next natural boundary - tomorrow, next
 * Monday, the 1st of next month, or the first day of next quarter. Matches the legacy product's
 * "weekly on Mondays, monthly on the 1st".
 */
export function nextReportRun(cadence: ReportSubscriptionCadence, from: Date = new Date()): string {
  const next = new Date(from);
  next.setHours(SEND_HOUR, 0, 0, 0);

  switch (cadence) {
    case 'daily':
      next.setDate(next.getDate() + 1);
      break;
    case 'weekly': {
      // getDay(): Sunday is 0, Monday is 1. A Monday asks for the following Monday.
      const daysUntilMonday = (8 - next.getDay()) % 7 || 7;
      next.setDate(next.getDate() + daysUntilMonday);
      break;
    }
    case 'monthly':
      next.setMonth(next.getMonth() + 1, 1);
      break;
    case 'quarterly': {
      const nextQuarterMonth = (Math.floor(next.getMonth() / 3) + 1) * 3;
      next.setMonth(nextQuarterMonth, 1);
      break;
    }
  }
  return next.toISOString();
}
